// extracted by mini-css-extract-plugin
export default {"root":"App_root__xbSs8","wrapper":"App_wrapper__NdFuT","secondRoot":"App_secondRoot__vMvT+","spinWrapper":"App_spinWrapper__yF0-8"};